<template>
  <v-form v-bind="this.$attrs">
    <div>
      <v-row no-gutters>
        <v-col cols="10">
          <v-row>
            <v-col cols="4">
              <v-select
                :items="exams"
                v-model="exam"
                label="Kỳ kiểm tra"
                item-value="id"
                item-text="name"
                return-object
                outlined
                dense
                hide-details
                @change="examSelected"
              ></v-select>
            </v-col>
            <v-col cols="4">
              <v-select
                :items="subjectGroups"
                v-model="subjectGroup"
                label="Môn"
                item-value="id"
                item-text="title"
                return-object
                :disabled="!exam"
                outlined
                dense
                hide-details
              ></v-select>
            </v-col>
            <v-col cols="4">
              <v-select
                :items="classes"
                v-model="clazz"
                label="Lớp"
                item-value="id"
                item-text="title"
                return-object
                outlined
                :disabled="!exam"
                dense
                clearable
                class="pr-6"
                hide-details
              ></v-select>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="2">
          <v-btn
            :disabled="!exam || !subjectGroup || !clazz"
            height="40"
            width="100%"
            style="background-color: white"
            color="#0D47A1"
            @click="onFilterChanged"
            outlined
          >
            Xác nhận
          </v-btn>
        </v-col>
      </v-row>
    </div>
  </v-form>
</template>

<script>
import { mapActions } from 'vuex'
import { Teaching } from '../../plugins/api'

export default {
  props: {},
  data() {
    return {
      exam: null,
      clazz: null,
      subjectGroup: null,
      exams: [],
      subjectGroups: [],
      classes: []
    }
  },
  async mounted() {
    await this.getExams()
  },
  methods: {
    ...mapActions('subjectExam', ['fetchSubjects']),
    ...mapActions('roomSubject', ['fetchRoomSubjects']),
    ...mapActions('exam', ['fetchExams']),
    ...mapActions('teacherExam', ['fetchTeacherExams']),
    onFilterChanged() {
      const params = {
        exam: this.exam.id,
        subjectGroup: this.subjectGroup ? this.subjectGroup._id : '',
        class: this.clazz ? this.clazz.id : ''
      }

      this.$emit('onFilterChanged', params, this.subjectGroup, this.clazz, this.exam)
    },
    async getExams() {
      this.$loading.active = true
      this.exams = await this.fetchExams({ status: 'active', hasTeacherGrade: 'true' })
      this.$loading.active = false
    },

    async examSelected() {
      this.$loading.active = true
      const res = await Teaching.getTeachingGroupAndClass(this.$auth.user.teacher)
      this.subjectGroups = res.subjectGroups
      this.classes = res.classes
      this.$loading.active = false
    }
  }
}
</script>
